var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:'complaint-list',class:'complaint-list',attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":_vm.getPersistenceKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }